"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProvider = exports.getAppointment = void 0;
const API_1 = require("../../../lib/API");
const getAppointment = '@service/GET_APPOINTMENT';
exports.getAppointment = getAppointment;
const getProvider = '@service/GET_PROVIDER';
exports.getProvider = getProvider;
const services = {
    [getAppointment]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        return (0, API_1.getAppointmentById)(context.services.getAppointment, context.appointmentId);
    }),
    [getProvider]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        return (0, API_1.getProviderById)(context.services.getProvider, ((_a = context.appointment) === null || _a === void 0 ? void 0 : _a.provider.provider_pma_id) ||
            ((_b = context.appointment) === null || _b === void 0 ? void 0 : _b.provider.provider_ehr_id));
    })
};
exports.default = services;
//# sourceMappingURL=services.loadingMachine.js.map